import { api } from '@/lib/api';

export type DashboardLocacaoRow = {
  id: string;
  idLocacao: string | null;
  nomeEmpresa: string | null;
  nomeCliente: string | null;
  clienteFornecedorId: string | null;
  companyId: string | null;
  placaEquipamento: string | null;
  modeloEquipamento: string | null;
  fabricanteEquipamento: string | null;
  statusAtual: string | null;
  dataInicioContrato: string;
  dataFimContratoEsperado: string | null;
  dataCancelamento: string | null;
  motivoCancelamento: string | null;
  nomeVendedor: string | null;
  statusDocumentoClickSign: string | null;
  statusEquipamento: string | null;
  porcentagemPago: number;
  valorTotalPago: number;
  totalVencido: number;
  totalAberto: number;
  totalMultas: number;
  multasPagas: number;
  multasVencidas: number;
  contatosRecebidos: number;
  quantidadeOs: number;
};

export type DashboardLocacoesResponse = {
  items: DashboardLocacaoRow[];
  total: number;
  page: number;
  limit: number;
  statuses: string[];
};

export type DashboardLocacoesSortKey =
  | 'nomeEmpresa'
  | 'nomeCliente'
  | 'placaEquipamento'
  | 'modelo'
  | 'statusAtual'
  | 'dataInicioContrato'
  | 'dataFimContratoEsperado'
  | 'nomeVendedor'
  | 'porcentagemPago'
  | 'valorTotalPago'
  | 'totalVencido'
  | 'totalAberto'
  | 'totalMultas'
  | 'multasPagas'
  | 'multasVencidas'
  | 'contatosRecebidos'
  | 'quantidadeOs'
  | 'statusDocumentoClickSign'
  | 'dataCancelamento';

export type DashboardLocacoesFilters = {
  companyId?: string;
  statusAtual?: string;
  search?: string;
  page?: number;
  limit?: number;
  sortBy?: DashboardLocacoesSortKey;
  sortDir?: 'asc' | 'desc';
};

export const dashboardLocacoesService = {
  async list(filters: DashboardLocacoesFilters = {}): Promise<DashboardLocacoesResponse> {
    const params: Record<string, string | number> = {};
    if (filters.companyId) params.companyId = filters.companyId;
    if (filters.statusAtual) params.statusAtual = filters.statusAtual;
    if (filters.search) params.search = filters.search;
    if (filters.page) params.page = filters.page;
    if (filters.limit) params.limit = filters.limit;
    if (filters.sortBy) params.sortBy = filters.sortBy;
    if (filters.sortDir) params.sortDir = filters.sortDir;

    const response = await api.get<{ success: boolean; data: DashboardLocacoesResponse }>(
      '/reports/dashboard/locacoes',
      { params }
    );
    return response.data.data;
  },
};
